import React, { useRef } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./ProjectCard.css"
import SliderWrapper from "../SliderWrapper"
import PrimaryButton from "../Buttons/PrimaryButton"

export default function ProjectCard({ data }) {
  console.log(data)
  const ref = useRef()
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  }

  const arrow = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.38086 12.0467L2.33419 7.99999L6.38086 3.95333"
        stroke="#0E0E0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.666 8L2.44602 8"
        stroke="#0E0E0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  return (
    <div className="vt-projecten__card">
      <div className="vt-projecten__card--content">
        <div className="vt-pojecten__card-slider">
          <SliderWrapper sliderRef={ref} settings={settings}>
            {data.projecten.galerij &&
              Array.isArray(data.projecten.galerij) &&
              data.projecten.galerij.map(img => {
                const image = getImage(
                  img.localFile.childImageSharp.gatsbyImageData
                )
                return (
                  <GatsbyImage
                    className="vt-projecten-image"
                    image={image}
                    key={img.id}
                    alt="Project image"
                  />
                )
              })}
          </SliderWrapper>
        </div>

        <div className="vt-projecten__card-inner-content">
          <div
            className="vt-projecten__button vt-projecten__button--prev"
            onClick={() => ref?.current?.slickPrev()}
          >
            {arrow}
          </div>
          <div
            className="vt-projecten__button vt-projecten__button--next"
            onClick={() => ref?.current?.slickNext()}
          >
            {arrow}
          </div>
          <div className="vt-projecten__card-inner-title">
            <h4>{data.title}</h4>
            <div dangerouslySetInnerHTML={{ __html: data.excerpt }}></div>
          </div>
          <div className="vt-projecten__tag-container">
            {data.projecten.tags.map(tag => (
              <div key={tag.label} className="vt-projecten__tag">
                <img src={tag.icon.localFile.publicURL} alt={tag.label} />
                <span>{tag.label}</span>
              </div>
            ))}
          </div>
          {data.projecten.buttonKlant.label ? (
            <PrimaryButton
              className="vt-projecten__card-button"
              label={data.projecten.buttonKlant.label}
              color={"red"}
              target={data.projecten.buttonKlant.link}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
